module.exports = __webpack_public_path__ + "img/ic_design_item4.9a59b99e.png";